import { Fa_IconOption } from "./fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";

export const Icons_externalLink = new Fa_IconOption(11, ["fas fa-external-link-alt"]);

export const Icons_ellipsis = new Fa_IconOption(11, ["fas fa-ellipsis-h"]);

export const Icons_grin = new Fa_IconOption(11, ["far fa-grin"]);

export const Icons_check = new Fa_IconOption(11, ["fas fa-check"]);

export const Icons_users = new Fa_IconOption(11, ["fas fa-users"]);

export const Icons_spinner = new Fa_IconOption(11, ["fas fa-spinner"]);

export const Icons_exclamation = new Fa_IconOption(11, ["fas fa-exclamation"]);

export const Icons_question = new Fa_IconOption(11, ["fas fa-question"]);

